import React, { useEffect, useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { postRequest, downloadFile } from '../../../helpers/apiHandler';
import {
  formatWithoutCurrency, truncateString,
} from '../../../helpers/helperFunction';
import CloseIcon from '../../SVG/CloseIcon';
import './_overview.scss';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const SmsDetailModal = ({ campaignId, dateRange, show, setCampaignId, setSmsDetailShow }) => {
  const { access_token } = useSelector((state) => state.auth.user);

  const [smsDetails, setSmsDetails] = useState([]);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const columns = [
    {
      name: 'Mobile Number',
      sortable: true,
      center: 'true',
      selector: (row) => row.phone_number,
    },
    {
      name: 'Message',
      sortable: true,
      center: 'true',
      width: '350px',
      selector: (row) => truncateString(row.message, 180),
    },
    {
      name: 'Message \nCount',
      sortable: true,
      center: 'true',
      selector: (row) => row.message_count,
    },
    {
      name: 'Status',
      sortable: true,
      center: 'true',
      selector: (row) => row.status,
    },
    {
      name: 'Country',
      sortable: true,
      center: 'true',
      selector: (row) => row.country,
    },
    {
      name: 'SMS \nRate',
      sortable: true,
      center: 'true',
      selector: (row) => formatWithoutCurrency(row.country_cost, 3),
    },
    {
      name: 'Campaign \nCost',
      sortable: true,
      center: 'true',
      selector: (row) => row.total_cost,
    },
  ];

  if (white_label_perkeso) columns.splice(5, 2); // REMOVES Campaign Cost & SMS Rate

  const fetch_sms_details = () => {
    const body = {
      date_range: dateRange,
      campaign_id: campaignId,
    };

    postRequest(`/v2/campaign-sms-details`, body, access_token.token, (res) => {
      if (res.success) {
        const details = res.data.sms_details;
        setSmsDetails(details);
      }
    });
  }

  const handleDownload = () => {
    setLoadingDownload(true);

    downloadFile(
      {
        url: '/v2/campaign-sms-details',
        data: {
          sms_data: smsDetails,
          download_file: true
        },
        access_token: access_token,
        fileName: `SMS-Details.csv`,
      },
      (res) => {
        setLoadingDownload(false);
        if (res.success) {
          setAlertState({
            message: 'Your sms report have been successfully exported to csv.',
            show: true,
            variant: 'success',
          });
        }
      });
    setLoadingDownload(false);
  };

  useEffect(() => {
    if (show) {
      fetch_sms_details()
    }
  }, [show]);

  const handleClose = () => {
    setCampaignId(null);
    setSmsDetailShow(false);
    setSmsDetails([]);
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="xl">
      <Modal.Body className='sms-detail-modal'>
        <CloseIcon handleModalClose={handleClose} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '16px 16px 8px 8px' }}>
          <Modal.Title as="h4">
            SMS Campaign Details
          </Modal.Title>
          <Button
            variant="primary"
            disabled={loadingDownload}
            style={{ minWidth: 160 }}
            onClick={handleDownload}
          >
            Export to Excel
          </Button>
        </div>
        <DataTable columns={columns} data={smsDetails} pagination />
      </Modal.Body>
    </Modal>
  );
};

export default SmsDetailModal;
